import { Component, ViewChild } from '@angular/core';
import { DxDataGridComponent } from "devextreme-angular";
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { NotificationService } from 'src/app/common/component/notification/notification.service';
import { O2PortalGlobalAsuAwardsService } from './o2-portal-global-asu-awards.service';
import saveAs from 'file-saver';
@Component({
  selector: 'O2PortalGlobalASUAwards',
  templateUrl: './o2-portal-global-asu-awards.component.html',
  styleUrls: ['./o2-portal-global-asu-awards.component.scss']
})
export class O2PortalGlobalAsuAwardsComponent {
  isLoadPanelVisible: boolean = false;
  o2PortalGlobalASUAwardsData: any;
  readonly allowedPageSizes = [50, 100, 200];
  totalResultRowCount: number = 0;
  isExportButtonDisabled = true;
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

  constructor(private notificationService: NotificationService, private o2PortalGlobalAsuAwardsService: O2PortalGlobalAsuAwardsService) {
    this.getO2PortalGlobalASUAwards();
  }

  getO2PortalGlobalASUAwards() {
    this.isLoadPanelVisible = true;
    this.o2PortalGlobalAsuAwardsService.getO2PortalGlobalASUAwards().subscribe({
      next: o2PortalGlobalASUAwardsData => {
        this.o2PortalGlobalASUAwardsData = o2PortalGlobalASUAwardsData;
        this.isLoadPanelVisible = false;
        this.isExportButtonDisabled = false;
      },
      error: (error: any) => {
        this.isLoadPanelVisible = false;
        this.isExportButtonDisabled = true;
        this.notificationService.alert("error", "Error while fetching O2 Portal Global ASU Awards data", error);
      }
    });
  }

  resetFilters() {
    this.dataGrid.instance.clearFilter();
    this.dataGrid.instance.clearSorting();
  }

  // This method is to get total no of CURRENT row count in the grid
  // A function that is executed when the UI component is rendered and each time the component is repainted.
  onContentReady(eventName: any) {
    this.totalResultRowCount = eventName.component.totalCount();
  }
  exportExcel(e) {
    this.dataGrid.instance.columnOption('siteId', 'visible', true);
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
      component: this.dataGrid.instance,
      worksheet: worksheet
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'GlobalASUAwards.xlsx');
        });
    }).then(() => {
      this.dataGrid.instance.columnOption('siteId', 'visible', false);
    });
    e.cancel = true;
  }
}
